/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateUserPinRequestDto } from '../../models/create-user-pin-request-dto';
import { UserPinDto } from '../../models/user-pin-dto';

export interface CreateMyUserPin$Params {
  'X-API-Version'?: string;
      body?: CreateUserPinRequestDto
}

export function createMyUserPin(http: HttpClient, rootUrl: string, params?: CreateMyUserPin$Params, context?: HttpContext): Observable<StrictHttpResponse<UserPinDto>> {
  const rb = new RequestBuilder(rootUrl, createMyUserPin.PATH, 'post');
  if (params) {
    rb.header('X-API-Version', params['X-API-Version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserPinDto>;
    })
  );
}

createMyUserPin.PATH = '/api/user-pins/my';
